export const Constantes = {
  API_KEY: '01992e31fdfd7ec10b4fd337e54d19d08',
  UNIDADES_PERMITIDAS: [
    'GALON', 'LITRO', 'UNIDAD', 'TANQUE'
  ],
  UNIDAD_DEFAULT: 'GALON',
  ESTADOS_PERMITIDOS: [
    'ACTIVO',
    'INACTIVO',
    'ELIMINADO',
    'BLOQUEADO'
  ],
  CONDICIONES_AUTORIZACION: [
    {
      descripcion: 'POR CANTIDAD',
      valor: 'CANTIDAD'
    },
    {
      descripcion: 'POR VALOR',
      valor: 'VALOR'
    },
    {
      descripcion: 'LIBRE',
      valor: 'LIBRE'
    },
  ],
  CONDICIONES_AUTORIZACION_CON_ANTICIPO: [
    {
      descripcion: 'POR CANTIDAD',
      valor: 'CANTIDAD'
    },
    {
      descripcion: 'POR VALOR',
      valor: 'VALOR'
    }
  ],
  CONDICION_AUTORIZACION_DEFAULT: 'CANTIDAD',
  AUTORIZACION_ESTADOS_PERMITIDOS: [
    'PENDIENTE_CONFIRMACION',
    'PENDIENTE_RECONFIRMACION',
    'CONFIRMADA',
    'DEVUELTA',
    'CANCELADA',
    'ELIMINADO',
    'TEST',
    'OTRO'
  ],
  LECTURAS_MANGUERAS_SIN_CIERRE_COLUMNAS_PERMITIDAS: [
    {
      descripcion: 'ISLERO',
      valor: 'i.nombre_completo'
    },
    {
      descripcion: 'EDS',
      valor: 'e.nombre'
    },
    {
      descripcion: 'TIPO TURNO',
      valor: 't.tipo'
    }
  ],
  ESTADO_ACTIVO: 'ACTIVO',
  ESTADO_INACTIVO: 'INACTIVO',
  ESTADO_CONFIRMADA: 'CONFIRMADA',
  ESTADO_ELIMINADO: 'ELIMINADO',
  ESTADO_BLOQUEADO: 'BLOQUEADO',
  ESTADO_RECHAZADO: 'RECHAZADO',
  ESTADO_CONFIRMADO: 'CONFIRMADO',
  ESTADO_PENDIENTE_CONFIRMACION: 'PENDIENTE_CONFIRMACION',
  ESTADO_CANCELADA: 'CANCELADA',
  ESTADO_DEVUELTA: 'DEVUELTA',
  ESTADO_FINALIZADO: 'FINALIZADO',
  ESTADO_PENDIENTE_RECONFIRMACION: 'PENDIENTE_RECONFIRMACION',
  ROL_ADMIN: 1,
  ROL_ISLERO: 2,
  ROL_CLIENTE: 3,
  ROL_SUBCLIENTE: 4,
  HTTP: {
    PETICION_EXITOSA: {
      CODIGO: 200,
      MENSAJE: 'ACCIÓN REALIZADA CORRECTAMENTE'
    },
    CREADO_CORRECTAMENTE: {
      CODIGO: 201,
      MENSAJE: 'REGISTRO CREADO CORRECTAMENTE'
    },
    ACTUALIZADO_CORRECTAMENTE: {
      CODIGO: 204,
      MENSAJE: 'REGISTRO ACTUALIZADO CORRECTAMENTE'
    },
    MAL_FORMATO: {
      CODIGO: 400,
      MENSAJE: 'INFORMACIÓN MAL FORMATEADA'
    },
    ACCESO_NO_AUTORIZADO: {
      CODIGO: 401,
      MENSAJE: 'ACCESO NO AUTORIZADO'
    },
    ACCESO_DENEGADO: {
      CODIGO: 403,
      MENSAJE: 'ACCESO DENEGADO'
    },
    RECURSO_NO_ENCONTRADO: {
      CODIGO: 404,
      MENSAJE: 'REGISTRO NO ENCONTRADO'
    },
    ERROR_NEGOCIO: {
      CODIGO: 409,
      MENSAJE: 'ERROR DE NEGOCIO'
    },
    ERROR_MUCHAS_PETICIONES: {
      CODIGO: 429,
      MENSAJE: 'ERROR MUCHAS PETICIONES'
    },
    ERROR: {
      CODIGO: 500,
      MENSAJE: 'ERROR'
    }
  },
  ACCIONES_FRONTEND_HTTP_403: {
    VOLVER_INICIAR_SESION: 'VOLVER_INICIAR_SESION',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    SOLO_MOSTRAR_MENSAJE: 'SOLO_MOSTRAR_MENSAJE',
    CONFIRMAR_CIERRE: 'CONFIRMAR_CIERRE',
    VER_PAGINA_MUCHAS_PETICIONES: 'VER_PAGINA_MUCHAS_PETICIONES',
    VERIFICAR_CODIGO_VALIDACION: 'VERIFICAR_CODIGO_VALIDACION',
    BLOQUEAR_BOTON_NUEVA_AUTORIZACION: 'BLOQUEAR_BOTON_NUEVA_AUTORIZACION',
    INGRESAR_TURNO_ISLERO: 'INGRESAR_TURNO_ISLERO'
  },
  ADMIN_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NOMBRE COMPLETO',
      valor: 'nombre_completo'
    },
    {
      descripcion: 'IDENTIFICACIÓN',
      valor: 'identificacion'
    },
    {
      descripcion: 'ESTADO',
      valor: 'a.estado'
    },
    {
      descripcion: 'U. EDS',
      valor: 'u.nombre'
    }
  ],
  SURTIDOR_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NÚMERO',
      valor: 'numero'
    },
    {
      descripcion: 'EDS',
      valor: 'e.nombre'
    },
  ],
  PRODUCTO_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'DESCRIPCIÓN',
      valor: 'p.descripcion'
    },
    {
      descripcion: 'CODIGO',
      valor: 'p.codigo'
    },
    {
      descripcion: 'U. EDS',
      valor: 'u.nombre'
    },
    {
      descripcion: 'ESTADO',
      valor: 'p.estado'
    }
  ],
  PRODUCTO_TIPO: [
    'DIESEL',
    'GASOLINA',
    'UREA'
  ],
  CLIENTE_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NOMBRE COMPLETO O R. SOCIAL',
      valor: 'nombre_completo'
    },
    {
      descripcion: 'IDENTIFICACIÓN',
      valor: 'identificacion'
    },
    {
      descripcion: 'ESTADO',
      valor: 'estado'
    }
  ],
  SUBCLIENTE_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NOMBRE COMPLETO',
      valor: 'nombre_completo'
    },
    {
      descripcion: 'IDENTIFICACIÓN',
      valor: 'identificacion'
    },
    {
      descripcion: 'ESTADO',
      valor: 'estado'
    }
  ],
  ISLERO_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NOMBRE COMPLETO',
      valor: 'nombre_completo'
    },
    {
      descripcion: 'IDENTIFICACIÓN',
      valor: 'identificacion'
    },
    {
      descripcion: 'ESTADO',
      valor: 'i.estado'
    },
    {
      descripcion: 'U. EDS',
      valor: 'u.nombre'
    }
  ],
  LOGS_COLUMNAS_PERMITIDAS: [
    {
      descripcion: 'ACCIÓN',
      valor: 'accion'
    },
    {
      descripcion: 'OBSERVACIÓN',
      valor: 'observacion'
    },
    {
      descripcion: 'IP',
      valor: 'ip_address'
    },
    {
      descripcion: 'USUARIO_CODIGO',
      valor: 'usuario_codigo'
    }
  ],
  VEHICULO_COLUMNAS_PERMITIDAS: [
    {
      descripcion: 'PLACA',
      valor: 'placa'
    },
    {
      descripcion: 'ESTADO',
      valor: 'estado'
    }
  ],
  AUTORIZACIONES_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'CLIENTE',
      valor: 'c.nombre_completo'
    },
    {
      descripcion: 'PLACA',
      valor: 'v.placa'
    },
    {
      descripcion: 'PRODUCTO',
      valor: 'p.descripcion'
    },
    {
      descripcion: 'ESTADO',
      valor: 'a.estado'
    }
  ],
  SERVICIOS_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'CLIENTE',
      valor: 'c.nombre_completo'
    },
    {
      descripcion: 'PLACA',
      valor: 's.vehiculo_placa'
    },
    {
      descripcion: 'ISLERO',
      valor: 'i.nombre_completo'
    },
    {
      descripcion: 'PRODUCTO',
      valor: 's.producto_descripcion'
    },
    {
      descripcion: 'ESTADO',
      valor: 's.estado'
    },
    {
      descripcion: 'U. EDS',
      valor: 'u.nombre'
    }
  ],
  SERVICIOS_ISLERO_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'CLIENTE',
      valor: 'c.nombre_completo'
    },
    {
      descripcion: 'PLACA',
      valor: 's.vehiculo_placa'
    },
    {
      descripcion: 'PRODUCTO',
      valor: 's.producto_descripcion'
    }
  ],
  SERVICIOS_CLIENTE_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'PLACA',
      valor: 's.vehiculo_placa'
    },
    {
      descripcion: 'PRODUCTO',
      valor: 's.producto_descripcion'
    },
    {
      descripcion: 'U. EDS',
      valor: 'u.nombre'
    }
  ],
  RECOGIDAS_EFECTIVO_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NOMBRE ISLERO',
      valor: 'i.nombre_completo'
    }
  ],
  RECOGIDAS_EFECTIVO_ISLERO_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'TIPO TURNO',
      valor: 't.tipo'
    }
  ],
  CIERRES_TURNOS_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'TIPO TURNO',
      valor: 't.tipo'
    }
  ],
  CIERRES_TURNOS_ADMIN_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'ISLERO',
      valor: 'i.nombre_completo'
    },
    {
      descripcion: 'TIPO TURNO',
      valor: 't.tipo'
    }
  ],
  ANTICIPOS_CLIENTES_ADMIN_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'MEDIO',
      valor: 'a.medio'
    },
    {
      descripcion: 'CLIENTE',
      valor: 'c.nombre_completo'
    }
  ],
  ANTICIPOS_DISPONIBLES_CLIENTES_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'CLIENTE',
      valor: 'c.nombre_completo'
    }
  ],
  ANTICIPOS_CLIENTES_CLIENTE_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'MEDIO',
      valor: 'a.medio'
    }
  ],
  UBICACION_EDS_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NOMBRE',
      valor: 'nombre'
    },
    {
      descripcion: 'DIRECCCIÓN',
      valor: 'direccion'
    }
  ],
  EDS_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NOMBRE',
      valor: 'e.nombre'
    },
    {
      descripcion: 'RAZON SOCIAL',
      valor: 'e.razon_social'
    },
    {
      descripcion: 'NIT',
      valor: 'e.nit'
    }
  ],
  MANGUERAS_COLUMNAS_PERMITIDAS_CONDICION: [
    {
      descripcion: 'NÚMERO',
      valor: 'm.numero'
    },
    {
      descripcion: 'PRODUCTO',
      valor: 'p.descripcion'
    }
  ],
  CONDICION_BUSQUEDA_DEFAULT_NUMERO: 'numero',
  CONDICION_BUSQUEDA_DEFAULT_NUMERO_MANGUERA: 'm.numero',
  CONDICION_BUSQUEDA_DEFAULT_NOMBRE_COMPLETO: 'nombre_completo',
  CONDICION_BUSQUEDA_DEFAULT_DESCRIPCION: 'p.descripcion',
  CONDICION_BUSQUEDA_DEFAULT_ACCION: 'accion',
  CONDICION_BUSQUEDA_DEFAULT_PLACA: 'placa',
  BUSCAR_POR_CONDICION: 'BUSCAR_POR_CONDICION',
  BUSCAR_ENTRE_FECHAS: 'BUSCAR_ENTRE_FECHAS',
  BUSCAR_POR_CONDICION_ENTRE_FECHAS: 'BUSCAR_POR_CONDICION_ENTRE_FECHAS',
  TIPO_AUTORIZACION_POR_CANTIDAD: 'CANTIDAD',
  TIPO_AUTORIZACION_LIBRE: 'LIBRE',
  TIPO_AUTORIZACION_POR_VALOR: 'VALOR',
  CONDICIONES_BUSCAR_POR: [
    {
      descripcion: 'Buscar por Condición',
      valor: 'BUSCAR_POR_CONDICION'
    },
    {
      descripcion: 'Buscar entre Fechas',
      valor: 'BUSCAR_ENTRE_FECHAS'
    },
    {
      descripcion: 'Buscar entre Fechas y Condición',
      valor: 'BUSCAR_POR_CONDICION_ENTRE_FECHAS'
    }
  ],
  CONDICIONES_ISLERO_BUSCAR_POR: [
    {
      descripcion: 'Buscar por Condición',
      valor: 'BUSCAR_POR_CONDICION'
    }
  ],
  TIPO_IDENTIFICACIONES: [
    {
      descripcion: 'NIT',
      valor: 'nit'
    },
    {
      descripcion: 'CC',
      valor: 'cc'
    }
  ],
  TIPO_PAGOS: [
    {
      descripcion: 'CON ANTICIPO',
      valor: 'CON_ANTICIPO'
    },
    {
      descripcion: 'SIN ANTICIPO',
      valor: 'SIN_ANTICIPO'
    }
  ],
  TIPO_SUBCLIENTES: [
    {
      descripcion: 'AUTORIZADOR',
      valor: 'AUTORIZADOR'
    },
    {
      descripcion: 'CONSULTA',
      valor: 'CONSULTA'
    }
  ],
  MOTIVOS_RECONFIRMAR_AUTORIZACION: [
    {
      descripcion: 'ESPACIO INSUFICIENTE',
      valor: 'ESPACIO_INSUFICIENTE'
    }
  ],
  TIPOS_TURNOS: [
    {
      descripcion: 'TURNO1',
      valor: 'TURNO1'
    },
    {
      descripcion: 'TURNO2',
      valor: 'TURNO2'
    }
  ],
  MEDIO_PAGOS_CLIENTE: [
    {
      descripcion: 'TRANSFERENCIA',
      valor: 'TRANSFERENCIA'
    },
    {
      descripcion: 'BILLETERA DIGITAL',
      valor: 'BILLETERA'
    },
    {
      descripcion: 'CÓDIGO QR',
      valor: 'QR'
    }
  ],
  TURNO_TURNO1: 'TURNO1',
  TURNO_TURNO2: 'TURNO2',
  MOTIVO_RECONFIRMAR_ESPACIO_INSUFICIENTE: 'ESPACIO_INSUFICIENTE',
  MOTIVO_RECONFIRMAR_ERROR_INFORMACION: 'ERROR_INFORMACION',
  ADMIN_TIPO: [
    {
      descripcion: 'CON ACCIONES',
      valor: 'CON_ACCIONES'
    },
    {
      descripcion: 'SOLO CONSULTA',
      valor: 'SOLO_CONSULTA'
    }
  ]
}
